import { useState } from "react";
import DirhamSymbol from "../../common/DirhamSymbol";
import { isArabic } from "../../utils/util";

const MedicalReportFee = ({ medicalReportsFee, age, translationMap }) => {
  const [isFeeShowHide, setIsFeeShowHide] = useState(false);
  const feeToggal = () => {
    setIsFeeShowHide(!isFeeShowHide);
  };
  if (age >= 60) {
    return <div className="custom_accordion_box2">
            <button className="accordion-button">
                    <span>
                        {translationMap?.medicalReportFee}
                    </span>
                <span>
                    {translationMap?.free}
                </span>
            </button>
            <div className="accordion_content_box">
                <h6 className="MainTitleOne">
                    {translationMap?.patientAbove60Free}
                </h6>
            </div>

        </div>;
  }
  return (
    <>
            <div class="custom_accordion_box">
                <button onClick={feeToggal} class="btn accordion-button" type="button"
        aria-expanded={isFeeShowHide ? "true" : "false"}>
          
          <span>
            {translationMap?.medicalReportFee}
          </span>
                    <span>
             {isArabic() ?
               <>270<DirhamSymbol width={10} height={10} marginTop={-2} /></> :
               <><DirhamSymbol width={10} height={10} marginTop={-2} />270</>
             }
          </span>
                </button>

                {isFeeShowHide &&
        <div className={`collapse ${isFeeShowHide ? "show" : ""}`} id="collapseExample">
                        <div class="card card-body">
                            <ul>
                                <li>
                <span>
                  {translationMap?.report}
                </span>
                                    <span>
                  {isArabic() ?
                    <>250<DirhamSymbol width={10} height={8} marginTop={-2} /></> :
                    <><DirhamSymbol width={10} height={8} marginTop={-2} />250</>
                  }
                </span>
                                </li>
                                <li>
                <span>
                  {translationMap?.knowledgeFee}
                </span>
                                    <span>
                   {isArabic() ?
                     <>10<DirhamSymbol width={10} height={8} marginTop={-2} /></> :
                     <><DirhamSymbol width={10} height={8} marginTop={-2} />10</>
                   }
                </span>
                                </li>
                                <li>
                <span>
                  {translationMap?.innovationFee}
                </span>
                                    <span>
               {isArabic() ?
                 <>10<DirhamSymbol width={10} height={8} marginTop={-2} /></> :
                 <><DirhamSymbol width={10} height={8} marginTop={-2} />10</>
               }
                </span>
                                </li>
                            </ul>
                        </div>
                    </div>
        }
            </div>
        </>);

};

export default MedicalReportFee;